import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import composeRoutes from 'routes';
import getCategories from 'store/app/selector/getCategories';
import getOpRoutes from 'store/app/selector/getOpRoutes';
import { Category } from 'store/app/types';

const useRoutes = () => {
  const categories = useSelector(getCategories) as Category[] | undefined;
  const opRoutes = useSelector(getOpRoutes);

  return useMemo(() => (categories ? composeRoutes(categories, opRoutes) : []), [categories, opRoutes]);
};

export default useRoutes;
